import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'react-jss'
import classNames from 'classnames'

import Title from 'components/content-box/title'

import sharedStyles from 'components/shared-style'

const ContentBox = ({ children, title, subTitle, titleIcon, className, theme, styles }) => {
  const classes = sharedStyles(theme)

  return (
    <div className={classNames(classes.contentBox, className)} style={styles}>
      {title &&
        <Title icon={titleIcon}>
          {title}
          {subTitle && <p className={classes.subTitle}>{subTitle}</p>}
        </Title>
      }
      <div>{children}</div>
    </div>
  )
}

ContentBox.propTypes = {
  theme: PropTypes.object.isRequired,
  children: PropTypes.node,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  titleIcon: PropTypes.string,
}

export default withTheme(ContentBox)
